<template>
  <section>
    <!--工具条-->
    <el-form :inline="true" :model="dataForm" ref="lineForm">
      <el-form-item label="号码/ICCID:" prop="Tel">
        <el-input type="textarea" v-model="dataForm.Tel" placeholder="请输入号码/ICCID" clearable rows="1"></el-input>
      </el-form-item>
      <el-form-item label="组织架构">
        <TenantCustomersSelectVue v-model="dataForm.DepartmentId" style="width: 220px"></TenantCustomersSelectVue>
      </el-form-item>
      <el-form-item label="客户公司名称:" prop="CompanyName">
        <el-input v-model="dataForm.CompanyName" placeholder="请输入客户公司名称"></el-input>
      </el-form-item>
      <el-form-item label="所属运营商:" prop="SupplierName">
        <el-select v-model="dataForm.SupplierName" placeholder="请选择所属运营商" clearable>
          <el-option :value="v.KeyTag" v-for="v in yysList" :key="v.KeyTag" :label="v.KeyTag">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="操作状态:" prop="CallerStatus">
        <el-select v-model="dataForm.CallerStatus" placeholder="请选择操作状态" clearable>
          <el-option value="Normal" label="正常"> </el-option>
          <el-option value="IllegalDisable" label="违规停机"> </el-option>
          <el-option value="ManagerDisable" label="管理停机"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否启用过滤:" prop="IsEnabled">
        <el-select v-model="dataForm.IsEnabled" placeholder="请选择" clearable>
          <el-option label="启用" :value="true"> </el-option>
          <el-option label="未启用" :value="false"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否白名单:" prop="IsWhitelist">
        <el-select v-model="dataForm.IsWhitelist" placeholder="请选择" clearable>
          <el-option label="是" :value="true"> </el-option>
          <el-option label="否" :value="false"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="() => {
      page = 1;
      handleGetDataList();
    }" type="primary">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-permission="['/Card/NumberCard/Add']" type="primary" @click="addOrUpdateHandle()">单条新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-divider direction="vertical"></el-divider>
      </el-form-item>
      <el-form-item v-permission="['/Card/NumberCard/Add']">
        <el-button @click="uploadAddUpdate('add')" icon="cloud-upload" type="primary">批量上传</el-button>
      </el-form-item>
      <el-form-item>
        <el-divider direction="vertical"></el-divider>
      </el-form-item>
      <el-form-item>
        <el-button v-permission="['/Card/NumberCard/Edit']" @click="uploadAddUpdate('edit')" icon="cloud-upload"
          type="primary">批量修改</el-button>
      </el-form-item>
      <el-form-item>
        <el-divider direction="vertical"></el-divider>
      </el-form-item>
      <el-form-item>
        <el-button @click="ExportGetDataList()" icon="cloud-upload" type="primary">导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="dataList" v-loading="dataListLoading" ref="table" class="custom-tbl" style="width: 100%">
      <!-- <el-table-column type="selection" width="50"> </el-table-column> -->
      <!-- <el-table-column type="index" width="80"> </el-table-column> -->
      <el-table-column align="center" prop="DepartmentName" label="组织架构" />
      <el-table-column align="center" prop="CompanyName" label="客户名称" />
      <el-table-column align="center" prop="SupplierName" label="所属运营商" width="150" />
      <el-table-column align="center" prop="Tel" label="号码" width="150" />
      <el-table-column align="center" prop="ICCID" label="ICCID" />
      <!-- <el-table-column align="center" prop="ProvinceName" label="省" width="150" />
      <el-table-column align="center" prop="CityName" label="市" width="150" /> -->
      <!-- <el-table-column align="center" prop="PhonePlan" label="套餐" width="350" />
      <el-table-column  align="center" prop="Amount" label="余额" v-permission="['/Card/NumberCard/Amount']"/>
      <el-table-column align="center" prop="ActiveTime" label="激活时间" width="250" />
      <el-table-column align="center" prop="StopOpenStatus" label="开关机状态" width="250"/> -->
      <el-table-column prop="CallerStatus" label="操作状态" width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.CallerStatus == 'Normal'
      ? 'success'
      : scope.row.CallerStatus == 'IllegalDisable'
        ? 'info'
        : 'warning'
      " disable-transitions>{{
      scope.row.CallerStatus == "Normal"
        ? "正常"
        : scope.row.CallerStatus == "IllegalDisable"
          ? "违规停机"
          : "管理停机"
    }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="IsEnabled" label="是否过滤">
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsEnabled ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsEnabled ? "启用" :
      "未启用" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="IsWhitelist" label="是否白名单" width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.IsWhitelist ? 'success' : 'danger'" disable-transitions>{{ scope.row.IsWhitelist ?
      "是" : "否" }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="CreateTime" label="创建时间" width="300" />
      <el-table-column label="操作" width="250" fixed="right">
        <template scope="scope">
          <el-button size="small" @click="addOrUpdateHandle(scope.row.Tel)"
            v-permission="['/Card/NumberCard/Edit']">编辑</el-button>
          <el-button type="danger" size="small" @click="deleteHandle(scope.row.Tel)"
            v-permission="['/Card/NumberCard/Delete']">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="pageSizeChangeHandle1" @current-change="pageCurrentChangeHandle1" :current-page="page"
      :page-sizes="pageSizes" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"
      style="float: right; margin-top: 15px">
    </el-pagination>
    <addOrUpdate ref="addOrUpdate" @ok="handleGetDataList"></addOrUpdate>
    <NumberMuchAddUpdateVue ref="numberMuchAddUpdateVue" @ok="handleGetDataList"></NumberMuchAddUpdateVue>
    <QueryTelInfo ref="QueryTelInfo"></QueryTelInfo>
  </section>
</template>

<script>
import viewModule from "@/mixins/view-module";
import addOrUpdate from "./components/NumberCardAddOrUpdate.vue";
import TenantCustomersSelectVue from "@/components/TenantCustomersSelect.vue";
import NumberMuchAddUpdateVue from "./components/NumberMuchAddUpdate.vue";
import QueryTelInfo from "./QueryTelInfo.vue";

export default {
  components: { addOrUpdate, TenantCustomersSelectVue, NumberMuchAddUpdateVue, QueryTelInfo },
  mixins: [viewModule],
  data() {
    return {
      dataForm: {
        Tel: "",
        DepartmentId: "",
        CompanyName: "",
        SupplierName: "",
        CallerStatus: "",
        IsEnabled: "",
        IsWhitelist: "",
        OpeningStatus: false,
      },
      mixinViewModuleOptions: {
        getDataListURL: "/api/TelListLog/PostAllCloseTelList",
        deleteURL: "/api/TelListLog/DeleteTelInfo",
        exportURL: "/api/TelListLog/ExportTelList",
        exportTelInfoURL: "/api/TelListLog/ExportTelQueryList",
        TelinfoURL: "/api/TelListLog/GetQueryInfo",
      },
      yysList: [],
      loadingAmountData: false, // 标志位，用于跟踪是否在加载 Amount 字段数据
      getDataListRequest: null, // 保存请求实例
    };
  },
  created() {
    this.getYys();
  },
  methods: {
    delayedLoadFieldData() {
      setTimeout(() => {
        this.loadFieldData();
      }, 1000);
    },
    QueryTel(tel) {
      this.QueryTelInfoVisible = true
      this.$nextTick(() => {
        this.$refs.QueryTelInfo.init(tel)
      })
    },
    pageSizeChangeHandle1(val) {
      this.page = 1
      this.limit = val
      this.handleGetDataList()
    },
    pageCurrentChangeHandle1(val) {
      this.page = val
      this.handleGetDataList()
    },
    handleGetDataList() {

      const oldtel = JSON.parse(JSON.stringify(this.dataForm.Tel));
      if (typeof this.dataForm.Tel === 'string') {
        this.dataForm.Tel = this.dataForm.Tel.split("\n").filter((v) => !!v);
      }
      this.query();
      this.dataForm.Tel = oldtel;
      // 如果不在加载 Amount 数据，则加载
      this.delayedLoadFieldData();
    },
    getYys() {
      this.$http
        .get("/api/common/GetDictionaryKeyVList?keyType=operators")
        .then((res) => {
          this.yysList = res.data.response.childrenList;
        });
    },
    // 触发加载 Amount 字段数据
    async loadFieldData() {
      // 设置加载标志
      this.loadingFieldData = true;

      // 调用后端接口加载字段数据
      const telList = this.dataList.map(item => item.Tel); // 获取所有的 Tel

      const request = this.$http.post(this.mixinViewModuleOptions.TelinfoURL, telList).then(response => {
        // 处理接口返回的数据

        const fieldData = response.data.response;
        console.log("后端数据"+response.data)
        this.dataList.forEach(item => {
          const tel = item.Tel;
          const telData = fieldData.find(data => data.Tel === tel); // 在 fieldData 数组中找到匹配的对象
          if (telData) {
            item.Amount = telData.Amount;
            item.PhonePlan = telData.PhonePlan;
            item.ActiveTime = telData.ActiveTime;
            item.StopOpenStatus = telData.StopOpenStatus;
          }
          else {
            console.log(`找不到 ${tel}`);
          }
        });
        // 重置加载标志
        this.loadingFieldData = false;
      }).catch(error => {
        console.error('Error loading field data: ', error);
        // 重置加载标志
        this.loadingFieldData = false;
      });
      // 保存请求实例
      this.getFieldDataRequest = request;
    },
    //新增或修改文件上传
    ExportGetDataList() {
      var oldtel = this.dataForm.Tel;
      if (typeof this.dataForm.Tel === 'string') {
        this.dataForm.Tel = this.dataForm.Tel.split("\n").filter((v) => !!v);
      }
      this.exportHandle().then;
      this.dataForm.Tel = oldtel;
      this.$message.success("导出完成");
    },
    async ExportTelInfoList() {
      const oldTel = this.dataForm.Tel;
      let exportInProgressMessage = null;
      try {
        // 二次确认
        await this.$confirm("确定要执行导出操作吗？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "info",
        });

        // 显示导出中提示框
        exportInProgressMessage = this.$message({
          message: "正在导出，请稍候...",
          type: "info",
          duration: 0,
        });

        // 保存原始电话号码数据并处理为数组
        if (typeof this.dataForm.Tel === 'string') {
          this.dataForm.Tel = this.dataForm.Tel.split("\n").filter((v) => !!v);
        }

        // 执行导出操作
        await this.exportTelInfoHandle();

        // 导出成功后关闭导出中提示框并提示导出完成
        exportInProgressMessage.close();
        this.$message.success("号卡详情导出操作成功，请耐心等待完成！");
      } catch (error) {
        console.error(error);
        if (exportInProgressMessage) {
          exportInProgressMessage.close();
        }
        throw error;
      } finally {
        // 恢复原始电话号码数据
        this.dataForm.Tel = oldTel;
      }
    },
    //新增或修改文件上传
    uploadAddUpdate(type) {
      this.$refs.numberMuchAddUpdateVue.init(type);
    },
    deleteHandle(id) {
      this.$confirm("是否删除当前选中数据", "提示！", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post(`${this.mixinViewModuleOptions.deleteURL}?tel=${[id]}`)
            .then(({ data: res }) => {
              this.$message.success(res.msg);
              this.handleGetDataList();
            })
            .catch(() => { });
        })
        .catch(() => { });
    }
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
